/*!
 * Planning Center Tapestry Web Components
 * Version: 1.3.0
 */
/**
 * Elements inside of web components sometimes need to inherit global attributes
 * set on the host. For example, the button in `tds-page-header-nav-item` should inherit
 * the aria attributes that developers set directly on `tds-page-header-nav-item`. This
 * helper function should be called in componentWillLoad and assigned to a variable
 * that is later used in the render function.
 * This function also removes the attribute from the parent when its set on child.
 *
 * This does not need to be reactive as changing attributes on the host element
 * does not trigger a re-render.
 */
function removeSSRSlot(host) {
    const ssrNodes = host.querySelectorAll('[slot="ssr"]');
    ssrNodes.forEach((el) => el.remove());
}

export { removeSSRSlot as r };
//# sourceMappingURL=p-Cfy_DCci.js.map
